import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { InsurerService } from '../../services/insurer/InsurerService'
import { InsurerState } from './types'

const initialState: InsurerState = {
  // state
  isFetchedAllInsurerLoading: false,
  isExportInsurersLoading: false,
  isAddInsurerLoading: false,
  isDeleteInsurerLoading: false,
  isFetchedInsurerInfoLoading: false,
  isFetchedAllPlanLoading: false,
  isFetchedInsurerAgreementLoading: false,
  isUpdateInsurerInfoLoading: false,
  isUpdateInsurerAgreementLoading: false,
  isUpdatePlanOrderLoading: false,
  isUpdateInsurerStatusLoading: false,
  isFetchedInsurerMasterDataLoading: false,
  insurerImage: null,
  isActive: true,
  // fetched
  fetchedAllInsurer: [],
  fetchedInsurersMasterData: []
}

const slice = createSlice({
  name: 'insurer',
  initialState,
  reducers: {
    toggleInsurerActive: (state) => {
      state.isActive = !state.isActive
    },
    setInsurerImage: (state, action: PayloadAction<File>) => {
      state.insurerImage = action.payload
    },
    onChangeInsurerAgreement: (state, action: PayloadAction<string>) => {
      state.insurerAgreement = action.payload
    },
    resetInsurerState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(InsurerService.getAllInsurerAsyncThunk.pending, (state) => {
        state.isFetchedAllInsurerLoading = true
      })
      .addCase(InsurerService.getAllInsurerAsyncThunk.rejected, (state) => {
        state.isFetchedAllInsurerLoading = false
      })
      .addCase(InsurerService.getAllInsurerAsyncThunk.fulfilled, (state, action) => {
        state.fetchedAllInsurer = action.payload
        state.isFetchedAllInsurerLoading = false
      })
      .addCase(InsurerService.exportInsurersAsyncThunk.pending, (state) => {
        state.isExportInsurersLoading = true
      })
      .addCase(InsurerService.exportInsurersAsyncThunk.rejected, (state) => {
        state.isExportInsurersLoading = false
      })
      .addCase(InsurerService.exportInsurersAsyncThunk.fulfilled, (state) => {
        state.isExportInsurersLoading = false
      })
      .addCase(InsurerService.addInsurerAsyncThunk.pending, (state) => {
        state.isAddInsurerLoading = true
      })
      .addCase(InsurerService.addInsurerAsyncThunk.rejected, (state) => {
        state.isAddInsurerLoading = false
      })
      .addCase(InsurerService.addInsurerAsyncThunk.fulfilled, (state) => {
        state.isAddInsurerLoading = false
      })
      .addCase(InsurerService.deleteInsurerAsyncThunk.pending, (state) => {
        state.isDeleteInsurerLoading = true
      })
      .addCase(InsurerService.deleteInsurerAsyncThunk.rejected, (state) => {
        state.isDeleteInsurerLoading = false
      })
      .addCase(InsurerService.deleteInsurerAsyncThunk.fulfilled, (state) => {
        state.isDeleteInsurerLoading = false
      })
      .addCase(InsurerService.getInsurerInfoAsyncThunk.pending, (state) => {
        state.isFetchedInsurerInfoLoading = true
      })
      .addCase(InsurerService.getInsurerInfoAsyncThunk.rejected, (state) => {
        state.isFetchedInsurerInfoLoading = false
      })
      .addCase(InsurerService.getInsurerInfoAsyncThunk.fulfilled, (state, action) => {
        state.fetchedInsurerInfo = action.payload
        state.isActive = action.payload.isActive
        state.isFetchedInsurerInfoLoading = false
      })
      .addCase(InsurerService.getAllPlanAsyncThunk.pending, (state) => {
        state.isFetchedAllPlanLoading = true
      })
      .addCase(InsurerService.getAllPlanAsyncThunk.rejected, (state) => {
        state.isFetchedAllPlanLoading = false
      })
      .addCase(InsurerService.getAllPlanAsyncThunk.fulfilled, (state, action) => {
        state.fetchedAllPlan = action.payload
        state.isFetchedAllPlanLoading = false
      })
      .addCase(InsurerService.getInsurerAgreementAsyncThunk.pending, (state) => {
        state.isFetchedInsurerAgreementLoading = true
      })
      .addCase(InsurerService.getInsurerAgreementAsyncThunk.rejected, (state) => {
        state.isFetchedInsurerAgreementLoading = false
      })
      .addCase(InsurerService.getInsurerAgreementAsyncThunk.fulfilled, (state, action) => {
        state.fetchedInsurerAgreement = action.payload
        state.insurerAgreement = action.payload
        state.isFetchedInsurerAgreementLoading = false
      })
      .addCase(InsurerService.updateInsurerInfoAsyncThunk.pending, (state) => {
        state.isUpdateInsurerInfoLoading = true
      })
      .addCase(InsurerService.updateInsurerInfoAsyncThunk.rejected, (state) => {
        state.isUpdateInsurerInfoLoading = false
      })
      .addCase(InsurerService.updateInsurerInfoAsyncThunk.fulfilled, (state) => {
        state.isUpdateInsurerInfoLoading = false
      })
      .addCase(InsurerService.updateInsurerAgreementAsyncThunk.pending, (state) => {
        state.isUpdateInsurerAgreementLoading = true
      })
      .addCase(InsurerService.updateInsurerAgreementAsyncThunk.rejected, (state) => {
        state.isUpdateInsurerAgreementLoading = false
      })
      .addCase(InsurerService.updateInsurerAgreementAsyncThunk.fulfilled, (state) => {
        state.isUpdateInsurerAgreementLoading = false
      })
      .addCase(InsurerService.updatePlanOrderAsyncThunk.pending, (state) => {
        state.isUpdatePlanOrderLoading = true
      })
      .addCase(InsurerService.updatePlanOrderAsyncThunk.rejected, (state) => {
        state.isUpdatePlanOrderLoading = false
      })
      .addCase(InsurerService.updatePlanOrderAsyncThunk.fulfilled, (state) => {
        state.isUpdatePlanOrderLoading = false
      })
      .addCase(InsurerService.updateInsurerStatusAsyncThunk.pending, (state) => {
        state.isUpdateInsurerStatusLoading = true
      })
      .addCase(InsurerService.updateInsurerStatusAsyncThunk.rejected, (state) => {
        state.isUpdateInsurerStatusLoading = false
      })
      .addCase(InsurerService.updateInsurerStatusAsyncThunk.fulfilled, (state) => {
        state.isUpdateInsurerStatusLoading = false
      })
      .addCase(InsurerService.getInsurerMasterDataAsyncThunk.pending, (state) => {
        state.isFetchedInsurerMasterDataLoading = true
      })
      .addCase(InsurerService.getInsurerMasterDataAsyncThunk.rejected, (state) => {
        state.isFetchedInsurerMasterDataLoading = false
      })
      .addCase(InsurerService.getInsurerMasterDataAsyncThunk.fulfilled, (state, action) => {
        state.fetchedInsurersMasterData = action.payload
        state.isFetchedInsurerMasterDataLoading = false
      })
  }
})

export const { resetInsurerState, toggleInsurerActive, setInsurerImage, onChangeInsurerAgreement } = slice.actions
export default slice.reducer
